// DS: B0
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Add from '@wix/da-ds/pkg/Icons/24x24/Add';
import { useSubmitMenuItem } from '../../../useSubmitMenuItem';
import { submitButtonMenuItem } from '../../../constants';
import s from './SubmitButton.scss';
var SubmitButton = function (_a) {
    var id = _a.id, className = _a.className, isOpen = _a.isOpen, onClick = _a.onClick, children = _a.children, ariaControls = _a["aria-controls"];
    var isUpdatedStyle = useFlag('submit_button_style');
    var t = useTranslation().t;
    var _b = useSubmitMenuItem(submitButtonMenuItem), href = _b.href, biData = _b.biData, submitOnClick = _b.onClick;
    if (isUpdatedStyle) {
        return (React.createElement(BrandedButton, { id: id, size: "medium", variant: "brand-green", icon: Add, className: className, href: href, onClick: submitOnClick, biData: biData, "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": ariaControls }, t('siteHeader.submit')));
    }
    return (React.createElement("button", { id: id, className: classnames(s['root'], className), "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": ariaControls, onClick: onClick }, children));
};
SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;
//# sourceMappingURL=SubmitButton.js.map